import { debounce } from 'lodash'

import {
  getSafeJSONValue,
  setJSONValue,
} from '../../../../../utils/local-storage'
import remarkDraftLoadMixin from './remark-draft-load-mixin'

const TTL_DAYS = 7
const TTL = TTL_DAYS * 24 * 3600 * 1000

export default {
  mixins: [remarkDraftLoadMixin],

  mounted() {
    this.debouncedStoreDraft = debounce(this.storeDraft, 200)
    this.cleanupExpired()
  },
  methods: {
    storeDraft(value) {
      if (value && value.trim().length) {
        const valueWithTTL = {
          value,
          expiry: (new Date().getTime() + TTL).toString(),
        }
        setJSONValue(this.draftLocalStorageKey, valueWithTTL)
      } else {
        this.cleanupDraft()
      }
    },
    cleanupDraft() {
      window.localStorage.removeItem(this.draftLocalStorageKey)
    },
    cleanupExpired() {
      const now = new Date().getTime()

      Object.keys(window.localStorage).forEach((key) => {
        const valueWithTTL = getSafeJSONValue(key)

        if (
          valueWithTTL &&
          valueWithTTL.expiry &&
          now > Number(valueWithTTL.expiry)
        ) {
          window.localStorage.removeItem(key)
        }
      })
    },
  },
  watch: {
    text(value, oldValue) {
      if (value !== oldValue) {
        this.debouncedStoreDraft(value)
      }
    },
  },
}
